// Home hero — inline video: click the poster to play, then the browser's native
// controls take over (volume, scrub, fullscreen). The play button only shows
// until the clip has started; it returns when the clip ends.
(function () {
  document.querySelectorAll('.mm-hero__video[data-has-video]').forEach(function (root) {
    var v = root.querySelector('.mm-hero__media');
    if (!v) return;

    root.addEventListener('click', function (e) {
      if (root.classList.contains('is-started')) return; // native controls own it now
      e.preventDefault();
      v.setAttribute('controls', 'controls');
      root.classList.add('is-started', 'is-playing');
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    });

    v.addEventListener('ended', function () {
      root.classList.remove('is-playing', 'is-started');
      v.removeAttribute('controls');
      v.load();
    });
  });
})();
